import React from 'react';
import PropTypes from 'prop-types';

import { StyledHeader, StyledDiv, ProgressBar, StyledText } from './FreeShipStyles';

var _ref = React.createElement('div', null);

var _ref2 = React.createElement(
  StyledText,
  null,
  'Yay! You\u2019ve earned Free Shipping!'
);

var FreeShip = function FreeShip(props) {
  // TEMP: Changing freeShipThreshold from 75 to 150 to 100
  var freeShipThreshold = parseInt(props.discountThresholdAmount);
  // const freeShipThreshold = 75;
  var subtotalPrice = parseInt(props.subtotalPrice);
  var amountFromThreshold = freeShipThreshold - subtotalPrice;

  var freeShipPercent = subtotalPrice / freeShipThreshold * 100;
  freeShipPercent = freeShipPercent > 100 ? 100 : freeShipPercent;

  return React.createElement(
    'div',
    null,
    React.createElement(
      StyledHeader,
      null,
      'FREE SHIPPING on Orders $',
      freeShipThreshold,
      '+'
    ),
    React.createElement(
      StyledDiv,
      null,
      React.createElement(
        ProgressBar,
        { freeShipPercent: freeShipPercent },
        _ref
      ),
      freeShipPercent === 100 ? _ref2 : React.createElement(
        StyledText,
        null,
        'You\'re ',
        React.createElement(
          'span',
          null,
          '$',
          amountFromThreshold
        ),
        ' away from Free Shipping'
      )
    )
  );
};

FreeShip.propTypes = {
  subtotalPrice: PropTypes.string,
  discountThresholdAmount: PropTypes.string
};

export default FreeShip;